import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, Component, useRef, useEffect, useState } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label
} from "reactstrap"

import moment from "moment"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { Link } from 'react-router-dom'

import Select from "react-select"
import YearSelect from '../../../../helpers/ui/YearSelect';
import Shimmer from "react-shimmer-effect";

import TableComponent from './Components/TableComponent'
import IndexBloc from '../Index/Blocs/IndexBloc'

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return ''
};


const PegawaiView = (props) => {

    const indexBloc = new IndexBloc()
    const activeRef = useRef();
    const [period, setPeriod] = useState()

    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    useEffect(() => {
        indexBloc.fetchDetail({ uuid: props.uuid })
        indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                        setPeriod(result.data.response)
                    break;
                default:
                    break;
            }
        })
        return () => {
            indexBloc.detailChannel?.unsubscribe()
        }
    }, [])

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end">
                            <Link to='/kepegawaian/pemberian_penghargaan.html' style={{ marginRight: 5 }}>
                                <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                            </Link>
                            <Button color="primary" style={{ marginRight: 5 }}><i className="uil-file-download-alt"></i> Export Excel</Button>
                        </div>
                        <CardTitle>Rekomendasi Pemberian Penghargaan</CardTitle>
                        <CardSubtitle className="mb-3">
                            Periode : {period?.award_period_year}
                        </CardSubtitle>
                        <hr/>
                        <TableComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} uuid={props.uuid}/>
                        <div>
                            <Link to='/kepegawaian/pemberian_penghargaan.html'>
                                <Button color="success"><i className="uil-backspace"></i> Kembali</Button>
                            </Link>
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>

    )
}

export default PegawaiView